var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgStepsIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10 4V5H13.293L9 9.293L6.8535 7.1465C6.75974 7.05276 6.63258 7.00011 6.5 7.00011C6.36742 7.00011 6.24026 7.05276 6.1465 7.1465L1 12.293L1.707 13L6.5 8.207L8.6465 10.3535C8.74026 10.4472 8.86742 10.4999 9 10.4999C9.13258 10.4999 9.25974 10.4472 9.3535 10.3535L14 5.707V9H15V4H10Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStepsIcon);
export default __webpack_public_path__ + "static/media/stepsIcon.99128e74422b9104ef466ce312b2cd31.svg";
export { ForwardRef as ReactComponent };